export function debtorSummaryText(): JSX.Element {
  return (
    <div className="Text">
      No quotes available yet.
      <br /> Go back and add a <b>Trellis</b>,<b> Gate</b>, or <b>Panel</b>.
    </div>
  );
}
